import { format_price_x100 } from 'console/billing/billing-utils';
export function getChangeBalanceText(balance_before_x100, balance_delta_x100) {
    if (!balance_before_x100 || !balance_delta_x100) {
        return '';
    }
    const result_x100 = balance_before_x100 + balance_delta_x100;
    const balance_before = format_price_x100(balance_before_x100, { with_rouble: false });
    const balance_delta = format_price_x100(balance_delta_x100, { with_rouble: false });
    const result = format_price_x100(result_x100, { with_rouble: true });
    if (balance_delta_x100 > 0) {
        return balance_before + '+' + balance_delta + ' = ' + result;
    }
    else {
        return balance_before + balance_delta + ' = ' + result;
    }
}
